// src/features/fourlink-config/components/shared/TurnoFilter.jsx

import React from 'react';

export const TurnoFilter = ({
  isOpen,
  search,
  selected,
  filteredOptions,
  buttonText,
  isActive,
  dropdownRef,
  onToggle,
  onSearchChange,
  onToggleSelection,
  onClear,
}) => {
  return (
    <div className="relative w-full md:w-auto" ref={dropdownRef}>
      <button
        type="button"
        onClick={onToggle}
        className={`flex w-full items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-offset-2 md:w-auto md:min-w-[200px] ${
          isActive
            ? 'border-blue-500 bg-blue-50 text-blue-700 focus:ring-blue-300'
            : 'border-gray-300 bg-white text-gray-600 hover:border-blue-400 focus:ring-blue-300'
        }`}
      >
        <span className="truncate flex-1 text-left">{buttonText}</span>
        <svg
          className={`h-4 w-4 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : 'rotate-0'}`}
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
        >
          <path d="M6 8l4 4 4-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="absolute right-0 z-30 mt-2 w-full rounded-lg border border-gray-200 bg-white shadow-xl md:w-80">
          <div className="border-b border-gray-100 p-2">
            <input
              type="text"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Buscar turno..."
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </div>
          <div className="max-h-[10.5rem] overflow-y-auto divide-y divide-gray-100">
            {filteredOptions.length === 0 ? (
              <p className="px-3 py-4 text-sm text-gray-500">
                {search ? 'No hay turnos que coincidan con la busqueda.' : 'No hay turnos disponibles.'}
              </p>
            ) : (
              filteredOptions.map((option) => {
                const isSelected = selected.includes(option.id);
                return (
                  <label
                    key={option.id}
                    className="flex cursor-pointer items-start gap-2 px-3 py-2 text-sm hover:bg-gray-50 transition-colors"
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => onToggleSelection(option.id)}
                      className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <span className="flex-1">
                      <span className="block font-medium text-gray-800">{option.label}</span>
                      <span className="block text-xs text-gray-500">{option.rangeText}</span>
                    </span>
                  </label>
                );
              })
            )}
          </div>
          <div className="flex items-center justify-between border-t border-gray-100 px-3 py-2 text-xs">
            <button
              type="button"
              onClick={onClear}
              className="font-semibold text-blue-600 hover:text-blue-800 disabled:cursor-not-allowed disabled:text-gray-400 transition-colors"
              disabled={!isActive && !search}
            >
              Limpiar filtro
            </button>
            <span className="text-gray-500">
              {selected.length > 0 && `${selected.length} seleccionado${selected.length !== 1 ? 's' : ''}`}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
